<div class="p-2">
  <div class="flex flex-wrap justify-content-between align-items-center mb-2">
    <div class="font-semibold text-2xl mb-3" data-clarity-unmask="true">{{ title }}</div>
  </div>
  <div class="main-card p-3 md:p-4 quick-start">
    <p class="text-gray-500 mb-4">
      {{
        mode === 'lectures'
          ? 'Wybierz grupę lub kursanta, a następnie stanowisko, na którym mają zostać uruchomione wykłady.'
          : 'Wybierz kursanta, a następnie stanowisko, na którym ma zostać uruchomiony egzamin wewnętrzny.'
      }}
    </p>

    <div class="target-selector" *ngIf="mode === 'lectures'">
      <button type="button" [class.active]="targetType === 'group'" (click)="targetType = 'group'" data-clarity-unmask="true">
        <i class="pi pi-users"></i>
        <span>Grupa</span>
      </button>
      <button type="button" [class.active]="targetType === 'student'" (click)="targetType = 'student'" data-clarity-unmask="true">
        <i class="pi pi-user"></i>
        <span>Kursant</span>
      </button>
    </div>

    <div class="form-row" *ngIf="targetType === 'group'">
      <label for="quickStartGroup" class="form-row__label">Grupa</label>
      <div class="form-row__control">
        <p-dropdown
          inputId="quickStartGroup"
          styleClass="w-full"
          [options]="groupOptions"
          [(ngModel)]="selectedGroupGuid"
          optionLabel="label"
          optionValue="value"
          placeholder="wybierz grupę"
          [filter]="true"
          filterBy="label"
          emptyMessage="Brak aktywnych grup"
          emptyFilterMessage="Nie znaleziono grupy"
          [loading]="loading"
          appendTo="body"
        >
          <ng-template let-option pTemplate="item">
            <div class="flex flex-column">
              <span>{{ option.label }}</span>
              <small class="text-gray-500" *ngIf="option.description">{{ option.description }}</small>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>

    <div class="form-row" *ngIf="targetType === 'student'">
      <label for="quickStartStudent" class="form-row__label">Kursant</label>
      <div class="form-row__control">
        <p-dropdown
          inputId="quickStartStudent"
          styleClass="w-full"
          [options]="studentOptions"
          [(ngModel)]="selectedStudentGuid"
          optionLabel="label"
          optionValue="value"
          placeholder="wybierz kursanta"
          [filter]="true"
          filterBy="label,description"
          emptyMessage="Brak aktywnych kursantów"
          emptyFilterMessage="Nie znaleziono kursanta"
          [loading]="loading"
          appendTo="body"
        >
          <ng-template let-option pTemplate="item">
            <div class="flex flex-column">
              <span>{{ option.label }}</span>
              <small class="text-gray-500" *ngIf="option.description">{{ option.description }}</small>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>

    <div class="flex justify-content-end pt-4">
      <p-button
        label="Wybierz stanowisko"
        icon="pi pi-arrow-right"
        iconPos="right"
        [disabled]="!canContinue || loading"
        (onClick)="continue()"
        data-clarity-unmask="true"
      ></p-button>
    </div>
  </div>
</div>
